<template>
    <div class="flex justify-between">
        <div class="flex items-center gap-1">
            <label :for="'toggle-' + model.name" class="cursor-pointer">{{ t(`setting.${model.name}.title`) }}</label>
            <UTooltip
                v-if="shouldShowTooltip"
                :text="helpText"
                :delay-duration="0"
                :ui="{
                    content: 'h-fit overflow-visible',
                    text: 'whitespace-pre-line p-1',
                }"
            >
                <i class="i-ph-info inline-block" />
            </UTooltip>
        </div>
        <USwitch :id="'toggle-' + model.name" v-model="switchValue" class="mx-2"/>
    </div>
</template>

<script setup lang="ts">
import {Setting} from '@/setting/setting.service'
import {computed} from 'vue'
import {useI18n} from 'vue-i18n'

const {t} = useI18n()

const model = defineModel<Setting<boolean>>({required: true})

const switchValue = computed({
    get: () => model.value.value ?? model.value.default,
    set: (val: boolean) => model.value.value = val
})

const helpText = computed(() => {
    return t(`setting.${model.value.name}.tooltip`)
})

const shouldShowTooltip = computed(
    () => helpText.value !== ''
)

</script>

<style scoped>

</style>